import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout route for the inscription wizard. Renders the matched step via
 * `<Outlet />`; the index route applies the `HomeGate` (onboarding obrigatório).
 */
export const Route = createFileRoute('/vagas/$jobId_/inscricao')({
  component: Outlet,
});
